// personnelActivityHistory.js — Activity History modal for Personnel Metrics.
// Receives the selected personnel object as a prop.
// Rendered inside the shared Modal component.

import React from "react";

const JobStatusBadge = ({ status }) => {
  const cls = {
    Completed: "pm-job-badge--completed",
    "In Progress": "pm-job-badge--inprogress",
    Pending: "pm-job-badge--pending",
  };
  return <span className={`pm-job-badge ${cls[status] || ""}`}>{status}</span>;
};

const PersonnelActivityHistory = ({ person }) => (
  <>
    <p className="modal-description">
      Today's job history for {person.fullName} &mdash; {person.employeeId}{" "}
      &bull; {person.department}
    </p>
    <div className="modal-section modal-section--scroll">
      <h3>Job Activity</h3>
      <div className="modal-table-scroll">
        <table className="modal-table">
          <thead>
            <tr>
              <th>Job Name</th>
              <th>Job ID</th>
              <th>Status</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {person.activityHistory.map((row) => (
              <tr key={row.jobId}>
                <td>{row.jobName}</td>
                <td>{row.jobId}</td>
                <td>
                  <JobStatusBadge status={row.status} />
                </td>
                <td>{row.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
);

export default PersonnelActivityHistory;
